<template>
    <div class="login">
        <div style="height:25%">
            <div><a href="http://www.heclar.cn/"><img src="../../assets/img/logo/z_logo.png" style="padding-left:10px;padding-top:10px;"/></a></div>
        </div>
        <div class="content">
            <div class="left">
                <div class="logo"><img src="../../assets/img/logo/logo.png" style="padding-top:10px;"/></div>
                <div class="font">
                    <div>海柯蓝MIMS</div>
                    <div>Market Information Management System</div>
                </div>
            </div>
            <div class="right">
                <el-form :model="ruleForm" status-icon ref="ruleForm" class="demo-ruleForm">
                    <el-form-item label="账号" prop="Username">
                        <el-input v-model="ruleForm.userName"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="Password">
                        <el-input type="password" v-model="ruleForm.password"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm')" :loading="btns" :disabled="btns">登录
                        </el-button>
                    </el-form-item>
                </el-form>
                <el-checkbox v-model="checked"></el-checkbox>
                <span style="font-family: PingFangSC-Medium;font-size: 12px;color: #C0C5C8;text-align: left;">我已阅读并同意 《市场信息管理系统服务协议》</span>
            </div>
        </div>
    </div>
</template>
<script>
    import Common from '@/components/Common';
    import axios from 'axios';

    export default {
        data() {
            return {
                ruleForm: {
                    userName: '',
                    password: ''
                },
                btns: false,
                checked: true
            };
        },
        mounted: function () {

        },
        methods: {
            submitForm() {
                let that = this;
                that.btns = true;
                that.instancename = that.ruleForm.instanceName;
                that.username = that.ruleForm.userName;
                that.userpwd = that.ruleForm.password;
                if (that.checked !== true) {
                    that.$message.warning('请同意市场信息管理系统服务协议');
                    that.btns = false;
                    return false;
                }
                if (that.username == null || that.username == '') {
                    that.$message.warning('请输入用户账号');
                    that.btns = false;
                    return false;
                } else if (that.userpwd == null || that.userpwd == '') {
                    that.$message.warning('请输入密码');
                    that.clicks = false;
                    return false;
                } else {
                    let data = {
                        dealercode: that.username,
                        dealerpassword: that.userpwd
                    };
                    axios
                        .post(Common.Url + 'SysDealerUsers/Login', data)
                        .then(function (res) {
                            let resdata = res.data
                            if (resdata.Success == 1) {
                                let userdata = {
                                    username: resdata.DataContent.dealername,
                                    authority: resdata.DataContent.powlv,
                                    token: resdata.Token,
                                    Login_Code: resdata.DataContent.dealercode,
                                    iid: resdata.DataContent.iid,
                                    rolelv: resdata.DataContent.rolelv,
                                    isShowPoints: resdata.RightList,
                                    area: Common.methods.getArea(resdata.DataContent.area)
                                };
                                sessionStorage.setItem('userData', JSON.stringify(userdata));
                                if(userdata.authority == 0){
                                    that.$router.push({ path: '/bhome' });
                                } else {
                                    that.$router.push({ path: '/dhome' });
                                }
                            } else {
                                that.$message.error(resdata.Msg);
                            }
                            that.btns = false;
                        })
                        .catch(function (error) {
                            that.$message.error('错误提示: ' + error);
                            that.btns = false;
                        });
                }
            },
        }
    };
</script>

<style scoped lang="less">
    @import url('../../assets/css/common.css');
    @import url('../../assets/css/login.less');
</style>
